module.exports = __webpack_public_path__ + "static/assets/ad192f2fa6b174f2af741cb27e1d4c7b.png";